import React, { useState } from 'react';
//assets
import arrowHistoryPrice from 'img/arrow-history-price.svg';
import informativeNoteIcon from "img/informative-note-icon.svg";
//interface
import { BudgetHistoryProps, HistoryProps } from './interface';
import { HistorytSatusDescription } from 'components/Table/interface';
//utils
import { DateOutputStr } from 'utils/DateOutput';
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
import { PercentageWith4Digits } from 'utils/Percentage';
import { generateRandomId } from 'utils/GenerateRandomId';
import { currencyOutputNumber } from 'utils/CurrencyOutput';
//components
import Text from 'components/Text';
import { Visibility } from 'components/Visibility';
import { VisibilityConditional } from 'components/VisibilityConditional';
import GenericTooltip from "pages/Quotes/components/generics/Tooltip/Tooltip";
import {
  Img,
  Container,
  InformativeNotePrice,
  NoteSalePrice,
  Tooltip,
  ButtonHistory,
  ButtonContainer,
  ContainerHistory,
  FlexTable,
  Column,
  Row,
  RowRA,
  TableHistory,
  ContainerMoney,
  TableMoney,
} from './styles';

export const BudgetHistory: React.FC<BudgetHistoryProps> = (props) => {
  const { history, orderBudgetHistory, suggested } = props;
  const [showHistory, setShowHistory] = useState(false);

  const codeProduct = (item: HistoryProps) => (`${item.supplierProductCode} ${item.mapProductSequence > 0 ? `/ ${item.mapProductSequence}` : ""}`);

  const autoAnswerOption = (item: HistoryProps, indexAuto: number) => (
    <FlexTable key={indexAuto}>
      <RowRA width={IsNullOrEmpty(item.supplierProductCode) ? '693px' : '603px'}><span>RA: </span>{item.note}</RowRA>
    </FlexTable>
  );

  const renderIconNotePrice = (condition?: boolean) => {
    return (
      <Visibility visible={condition || false}>
        <InformativeNotePrice
          src={informativeNoteIcon}
          alt="informativeNoteIcon"
          className="lockIconUnitPrice"
        />
      </Visibility>
    );
  };

  const historyOption = (item: HistoryProps) => {
    const stockView = !!(item.pitagorasPosition && item.pitagorasPosition > 0);
    const distributionCenterStock = stockView ? `${item.pitagorasStock}/${item.pitagorasDistributionCenter}` : `${item.distributionCenterStock}`;
    return (
      <>
        <Row width='50px'>{item.distributionCenter}</Row>
        <Visibility visible={!!item.quantity}>
          <Row width='70px'>
            <Text showTip={stockView ?? false} showTipContent={`Pitágoras: ${item.pitagorasDistributionCenter}`}>
              {distributionCenterStock}
            </Text>
          </Row>
          <Row width='80px'>{PercentageWith4Digits(item.rentability)}</Row>
          <Row width='90px'><Tooltip>{renderIconNotePrice(item.acceptPriceBelowMin || item.isValuePricing)} <NoteSalePrice>{item.note}</NoteSalePrice></Tooltip> {currencyOutputNumber(item.salePrice)}</Row>
          <Row width='50px'>{item.quantity}</Row>
          <Row width='90px'>{currencyOutputNumber(item.totalValue)}</Row>
          <Row width='90px'>{item.unitPrice === 0 ? '-' : currencyOutputNumber(item.unitPrice)}</Row>
        </Visibility>
        <Visibility visible={false}>
          <GenericTooltip
            areaRight="2%"
            areaBottom="70%"
            disable
            width={"534px"}
            maxWidth={"534px"}
            height={"200px"}
            padding={"10px"}
            overflow={"hidden"}
          >
            {item.note}
          </GenericTooltip>
        </Visibility>
      </>
    );
  };

  const handleButtonHistory = () => {
    if (orderBudgetHistory) {
      return "Exibir histórico de envios";
    }
    return "Exibir histórico de edições";
  };

  const autoAnswerHistoryName = ["Resposta Automática", "Resposta Automatica"];

  return (
    <Container>
      <ButtonContainer onClick={() => setShowHistory(!showHistory)}>
        <Img showHistory={showHistory} src={arrowHistoryPrice} />
        <ButtonHistory>{handleButtonHistory()}</ButtonHistory>
        <Img showHistory={showHistory} src={arrowHistoryPrice} />
      </ButtonContainer>

      <ContainerHistory showHistory={showHistory}>
        <TableHistory>
          <FlexTable>
            <Column width='115px'>Data/hora de envio</Column>
            <Column width='130px'>Usuário</Column>
            <Column width='80px'>Status</Column>
            <Column width='90px'>Cód. Prod./Seq</Column>
            <Column width='50px'>Orçam.</Column>
            <Column width='70px'>Estoque</Column>
            <Column width='80px'>Margem</Column>
            <Column width='90px'>Preço venda</Column>
            <Column width='50px'>Qtd.</Column>
            <Column width='90px'>Valor total</Column>
            <Column width='90px'>Valor unit.</Column>
          </FlexTable>

          {
            history.map((item, index) => (
              <div key={generateRandomId(item.name)}>
                <FlexTable noteLenght={item?.note?.length}>
                  <Row width='115px'>{DateOutputStr(item.date)}</Row>
                  <Row width='130px'>{item.name}</Row>
                  <Row width='80px' redColor={item.statusDescription === HistorytSatusDescription.FAILURE || item.statusDescription === HistorytSatusDescription.NOT_DELETED}><span className='redLabel'>{item.statusDescription}</span></Row>
                  {!IsNullOrEmpty(item.supplierProductCode) && (
                    <Row width='90px'>
                      <Text showTipContent="Cód. Produto - Sequência De/Para" showTip>{codeProduct(item)}</Text>
                    </Row>
                  )}
                  <VisibilityConditional
                    key={String(`${item.date}${item.name}`)}
                    condition={(!item.autoAnswer && !IsNullOrEmpty(item.note) && autoAnswerHistoryName.includes(item.name)) || (item.autoAnswer && (item.deletedItem ?? false))}
                    firstOption={() => autoAnswerOption(item, index)}
                    secondOption={() => historyOption(item)}
                  />
                </FlexTable>
              </div>
            ))
          }
        </TableHistory>

        <TableHistory>
          <ContainerMoney>
            <TableMoney>
              <FlexTable>
                <Column width='75px'>Preço tipo 1</Column>
                <Column width='75px'>Preço tipo 2</Column>
              </FlexTable>

              {
                history.map((item) => (
                  <FlexTable noteLenght={item?.note?.length} key={String(`${item.date}${item.name}`)}>
                    <Row width='70px'>{item.minimumPrice ? currencyOutputNumber(item.minimumPrice) : '-'}</Row>
                    <Row width='70px'>{item.minimumPriceLock2 ? currencyOutputNumber(item.minimumPriceLock2) : '-'}</Row>
                  </FlexTable>
                ))
              }
            </TableMoney>
          </ContainerMoney>
        </TableHistory>
      </ContainerHistory>
    </Container>
  );
};;